module.exports = __webpack_public_path__ + "img/mopark.934ed723.jpg";